import { XIcon } from 'lucide-react'
import { useNavigate, useParams } from 'react-router-dom'

import { paths } from 'src/config/paths'
import { Button } from 'src/shared/components/ui/buttons/button'

import type { BCStepName } from '../constants/bc-config'
import { useBusinessCreateContext } from '../context/business-create-context'
import { ArrowBackIcon } from '../icons/arrow-back-icon'
import { useBusinessCreateStore } from '../store/business-create-store'

const BCHeader = () => {
  const { handleBack } = useBusinessCreateContext()
  const navigate = useNavigate()
  const { step } = useParams<{ step: BCStepName }>()
  const { formData } = useBusinessCreateStore()

  const locationType = formData.desiredLocationType || 'general'

  const handleCloseClick = () => {
    navigate(paths.business.path)
  }

  const hideTitle = locationType === 'general' && step === 'select-location'

  return (
    <div className="absolute inset-x-0 top-0 z-[100] flex flex-row items-center justify-between p-5">
      <div className="size-[60px]">
        {/* empty div, dont remove, used for spacing */}
        <Button variant="ghost" size="icon" onClick={handleBack} className="size-[60px] bg-accent hover:bg-accent">
          <ArrowBackIcon className="size-6" />
        </Button>
      </div>
      <p className="text-base font-semibold">{hideTitle ? '' : 'Create business'}</p>
      <Button variant="ghost" size="icon" onClick={handleCloseClick} className="size-[60px] bg-accent hover:bg-accent">
        <XIcon className="size-8" />
      </Button>
    </div>
  )
}

export default BCHeader
